<div *ngIf="storeValue !== 'agreed'" class="cookie-consent-container">
    <h5>Este sitio web utiliza cookies para el necesario funcionamiento de la aplicación.</h5>
    <button value="false" class="cookie-consent-deny" (click)="saveDecision()">Aceptar</button>
</div>
